import { createContext } from 'react';

import { Product, ProductReport } from '@totem/components/endoflife/types';

interface Context {
  loading: boolean;
  reportData: ProductReport;
  totalRecords: number;
  onAction: (action: string, product: Product) => void;
}

export default createContext<Context>({
  loading: false,
  reportData: null,
  totalRecords: 0,
  onAction: () => {},
});
